module.exports = __webpack_public_path__ + "img/ticket_count.01f59fff.svg";